
export function creditCard (state) {
    return state.creditCard
}

export function creditCardExpirationMonth (state) {
    return state.creditCard.expiration.split("/")[0].padStart(2, "0")
}

export function creditCardExpirationYear (state) {
    return state.creditCard.expiration.split("/")[1].padStart(4, "0")
}